import { useState, useEffect } from 'react';
import axiosInstance from 'axiosInstance';

const useAgentsList = () => {
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axiosInstance
      .get('agents/list')
      .then(res => {
        if (!cancelled) {
          setAgents(res.data.agents || []);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return agents;
};

export default useAgentsList;
